import React from "react";
import { Card, CardContent, Typography, Box, Grid2 } from "@mui/material";
import ScrollableWithGradients from "./ScrollableWithGradients";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import BlockIcon from "@mui/icons-material/Block";
import CancelIcon from "@mui/icons-material/Cancel";
import { AttachMoney, ThumbUp } from "@mui/icons-material";

const LessonList = ({
  lessons,
  selectedLesson,
  setSelectedLesson,
  handleSelectedLesson = () => {},
  selectedLessons,
  setSelectedLessons,
  selectedStudent,
  setSelectedStudent = () => {},
  multiselect = false
}) => {

  const isSelected = (lesson) =>
    multiselect
      ? selectedLessons.some((l) => l.uid === lesson.uid)
      : selectedLesson?.uid === lesson.uid;

  const selectLesson = (lesson) => {
    if (multiselect) {
      const isSelected = selectedLesson.some((l) => l.uid === lesson.uid);
      const newSelected = isSelected
        ? selectedLessons.filter((u) => u.uid !== lesson.uid)
        : [...selectedLessons, lesson];
      setSelectedLessons(newSelected);
    } else {
      if (selectedLesson === lesson) {
        setSelectedLesson(null);
      } else {
        setSelectedLesson(lesson);
        handleSelectedLesson(lesson);
      }
      setSelectedStudent(null);
    }
  };

  function getStatusIcon(status) {
    switch (status) {
      case "confirmed":
      case "submitted":
        return <ThumbUp sx={{ color: "green" }} />;
      case "requested":
      case "rescheduled":
      case "rejected":
        return <WarningAmberIcon sx={{ color: "gold" }} />;
      case "proposed":
      case "moved":
        return <HourglassTopIcon sx={{ color: "blue" }} />;
      case "cancelled":
        return <BlockIcon sx={{ color: "red" }} />;
      case "deleted":
        return <CancelIcon sx={{ color: "yellow" }} />;
      case "billed":
        return <AttachMoney sx={{ color: "purple" }} />;
      case "finished":
        return <CheckCircleIcon sx={{ color: "green" }} />;
      default:
        return null;
    }
  }

  return (

      <Grid2>
            <ScrollableWithGradients>
        <Box display="flex" flexDirection="column" gap={2}>
          {lessons.map((lesson) => {
            return (
              <Card
                key={lesson.uid}
                onClick={() => {
                  selectLesson(lesson);
                }}
                sx={{
                  cursor: "pointer",
                  backgroundColor: isSelected(lesson) ? "#d0f0d0" : "white",
                  "&:hover": {
                    backgroundColor: isSelected(lesson) ? "#d0f0d0" : "#e6f2ff",
                  },
                  position: "relative",
                }}
              >
                <CardContent>

                  <Box sx={{ position: "absolute", top: 8, right: 8 }}>
                    {getStatusIcon(lesson.status)}
                  </Box>

                  <Typography variant="h6">{lesson.name}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {new Date(lesson.startDttm).toLocaleString()} -{" "}
                    {new Date(lesson.endDttm).toLocaleTimeString()}
                  </Typography>
                  <Typography variant="body2">
                    Fee: {lesson.fee} {lesson.ccy}
                  </Typography>
                  {isNaN(lesson.balance) ? ("") :
                    <Typography
                      variant="body2"
                      color={['finished', 'billed'].includes(lesson.status) && lesson.balance < 0 ? "error" : "success.main"}
                    >
                      Balance: {lesson.balance}
                    </Typography>}

                </CardContent>
              </Card>
            );
          })}
        </Box>
            </ScrollableWithGradients>
      </Grid2>

  );
};

export default LessonList;
